export function maxPromisableAmount(outstanding: number, alreadyPromised: number): number {
  return Math.abs(alreadyPromised) > Math.abs(outstanding) ? alreadyPromised : outstanding;
}
